import { useMemo } from 'react';

import { maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export default function HyperliquidTradeDetails({ trigger, triggerType }: Props) {
  const builderDisplay = useMemo(() => {
    const builderAddress = trigger.context?.builderAddress;

    if (!builderAddress) {
      return 'N/A';
    }

    const builderNames: Record<string, string> = {
      '0x8af3545a3988b7A46f96F9F1AE40c0e64Fa493C2': 'HyperSignals',
    };

    return builderNames[builderAddress] || maskAddressValue(builderAddress);
  }, [trigger.context?.builderAddress]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerValueDetail label="Builder" value={builderDisplay} />
    </div>
  );
}
